import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import { mapModes, stateCodes } from "./constants";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App mapMode="" />}></Route>
      <Route path="/:view" element={<App mapMode="" />}></Route>
      <Route path="/pa" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.PA} enableS4sGrantees={true} />}></Route>
      <Route path="/pa/:view" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.PA} enableS4sGrantees={true} />}></Route>
      <Route path="/va" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.VA} />}></Route>
      <Route path="/va/:view" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.VA} />}></Route>
      <Route path="/md" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.MD} />}></Route>
      <Route path="/md/:view" element={<App mapMode={mapModes.STATE} stateCode={stateCodes.MD} />}></Route>
      <Route path="/mea" element={<App mapMode={mapModes.MEA} stateCode={stateCodes.MD} />}></Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
